/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Manage any JS for the login dialog
//
// Does not include code to trigger facebook or linkedin logins, see
// respective modules for that
//
// data-login=container
// data-login-target on a[data-action=change-tab]
// data-login-tab gets shown

// Login lightbox handler
namespace('Slzr.Login', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  // Enable it for each login container on page
  $(() => $(document).on('click', '[data-login="container"] [data-action="change-tab"]', function(evt) {
    const $element = $(this);
    const $container = $element.closest('[data-login="container"]');
    const tab = $element.data('login-target');

    // Highlight current tab
    $container.find('[data-action="change-tab"]').removeClass('current');
    $element.addClass('current');

    // Show right login tab
    $container.find('div[data-login-tab]').hide();
    $container.find(`div[data-login-tab=\"${tab}\"]`).show();

    // and finalize
    $.fancybox.resize();
    return evt.preventDefault();
  }));

  // LEGACY CODE
  const switchLogin = function(el) {
    let service;
    el = $(el);
    const root = el.closest('div.localist_modal_container');

    // Get the class from the button
    if (el[0].className.match(/button-login-([a-z]+)/i)) { service = RegExp.$1; }

    if (service) {
      // Move class to the new button
      root.find('div.login_choices a.current').removeClass('current');
      el.addClass('current');

      // Show the appropriate div
      root.find('div[class^=container-login]').hide();
      root.find(`div.container-login-${service}`).show();

      // Resize lightbox if necessary
      return $.fancybox.resize();
    }
  };

  return exports.switchLogin = switchLogin;
});
